// extracted by mini-css-extract-plugin
export default {"inlineEdit":"_0k5uIF2L6FVmcxNgWw8"};